import { render, staticRenderFns } from "./TermsAndPrivacyPolicy.vue?vue&type=template&id=943dde2a&"
import script from "./TermsAndPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./TermsAndPrivacyPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports